// extracted by mini-css-extract-plugin
module.exports = {"nameArea":"NameArea_nameArea__KVJn6","ratingArea":"NameArea_ratingArea__KDp1_","name":"NameArea_name__EVRlp","info":"NameArea_info__yVmcc","iconMap":"NameArea_iconMap__KIqLj"};